import { get, httpDelete, patch, post } from "@readai/common/api";
import type {
  CreateWebhookRequest,
  TestWebhookRequest,
  UpdateWebhookRequest,
  Webhook,
} from "@readai/common/types/webhookTypes";

import { parseWebhooks } from "../parsers/integrations";

export const listWebhooks = async (): Promise<Webhook[]> => {
  const res = await get("/integrations/webhooks", { withCreds: true });
  return parseWebhooks(res);
};

export const createWebhook = async (webhook: CreateWebhookRequest) => {
  return post("/integrations/webhooks", webhook, { withCreds: true });
};

export const updateWebhook = async ({ id, ...body }: UpdateWebhookRequest) => {
  return patch(`/integrations/webhooks/${id}`, body, {
    withCreds: true,
  });
};

export const deleteWebhook = async (id: Webhook["id"]) => {
  return httpDelete(`/integrations/webhooks/${id}`, { withCreds: true });
};

export const sendTestRequest = async (webhook: TestWebhookRequest) => {
  return post("/integrations/webhooks/test", webhook, {
    withCreds: true,
  });
};
